import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { inViewForReact } from 'utils/common';

class SocialInView extends React.Component {
  constructor() {
    super();
    this.show = false;
    this.lastScrollTop = 0;
    this.upScroll = '';
    this.shareRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.monitorScroll());
    this.footerElem = document.querySelector(
      `[data-footer="${this.props.msid}"]`,
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.monitorScroll());
  }

  monitorScroll = () => throttle(this.handleScrollEvent, 100);

  checkScrollDirection = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    let upScroll = true;
    if (st > this.lastScrollTop) {
      upScroll = false;
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
    return upScroll;
  };

  handleScrollEvent = () => {
    if (this.shareRef && this.shareRef.current) {
      const elem = this.shareRef.current;
      const isInView = inViewForReact(elem);
      let show = false;
      const elemRect = elem.getBoundingClientRect();
      const elemBottom = this.footerElem.getBoundingClientRect();
      let upScroll = '';
      if (
        !isInView &&
        elemRect &&
        elemRect.top <= 40 &&
        elemBottom &&
        elemBottom.top + 300 - window.innerHeight > 0
      ) {
        show = true;
        upScroll = this.checkScrollDirection();
      }

      if (this.show !== show || upScroll !== this.upScroll) {
        this.props.cbForSticky(show, upScroll, this.props.withminiwidget);
        this.show = show;
        this.upScroll = upScroll;
      }
    }
  };

  render() {
    return <div ref={this.shareRef} />;
  }
}

SocialInView.propTypes = {
  cbForSticky: PropTypes.func.isRequired,
  msid: PropTypes.func.isRequired,
  withminiwidget: PropTypes.bool,
};

SocialInView.defaultProps = {
  withminiwidget: false,
};

export default SocialInView;
